import axios from 'axios';

export default class ApiSimulador {
    public static get(id: number): Promise<CotacaoResponse> {
        return ApiSimulador.instance.get<CotacaoResponse>('/simulacao.php', { params: { id } })
            .then((response) => response.data);
    }

    public static create ( data: {} ): Promise<CriarCotacaoResponse> {
        return ApiSimulador.instance.post<CriarCotacaoResponse>('/simulacao.php', data )
            .then((response) => response.data);
    }

    public static update(data: {}): Promise<GenericResponse> {
        return ApiSimulador.instance.patch<GenericResponse>('/simulacao.php', data)
            .then((response) => response.data);
    }

    private static instance = axios.create({
        baseURL: 'https://simulador.protruck.org.br/api/v1/',
    });

}
